import { useThree } from '@react-three/fiber';
import { useEffect } from 'react';

/**
 * Componente que desativa o fog na cena para melhorar a visibilidade das parcelas distantes
 */
const FogDisabler = () => {
  const { scene } = useThree();
  
  useEffect(() => {
    // Armazenar o fog atual
    const originalFog = scene.fog;
    
    // Desativar o fog
    scene.fog = null;
    
    // Restaurar o fog original quando o componente for desmontado
    return () => {
      scene.fog = originalFog;
    };
  }, [scene]);
  
  // Este componente não renderiza nada visível
  return null;
};

export default FogDisabler;
